export default {
	namespaced: true,

	state: {
		VER001000: {
			version: 'Ver.1.0',
			date: '2019-10-19',
			summary: 'Features are released: <b>Reward Point App & Online Training Management</b>'
		},
		VER001001: {
			version: 'Ver.1.1',
			date: '2019-10-28',
			summary: 'Features added and improved.'
		},
		VER001002: {
			version: 'Ver.1.2',
			date: '2019-11-07',
			summary: 'Features added and improved.'
		},
		VER001003: {
			version: 'Ver.1.3',
			date: '2019-11-11',
			summary: 'Features added and improved.'
		},
		VER001004: {
			version: 'Ver.1.4',
			date: '2019-11-12',
			summary: 'Features added and improved.'
		},
		VER001005: {
			version: 'Ver.1.5',
			date: '2019-11-19',
			summary: 'Features added and improved.'
		},
		VER001006: {
			version: 'Ver.1.6',
			date: '2019-11-21',
			summary: 'New feature is added: <b>Sales Activity Management</b>'
		},
		VER001007: {
			version: 'Ver.1.7',
			date: '2020-01-10',
			summary: 'New feature is added: <b>Recruitment Management</b>'
		},
		VER001008: {
			version: 'Ver.1.8',
			date: '2020-01-23',
			summary: 'New feature is added: <b>Version Information</b>'
		},
		VER001009: {
			version: 'Ver.1.9',
			date: '2020-01-25',
			summary: 'New feature is added: <b>App Login Histories</b>'
		},
		VER001010: {
			version: 'Ver.1.10',
			date: '2020-01-27',
			summary: 'New feature is added: <b>Moment Timezone</b>'
		},
		VER001011: {
			version: 'Ver.1.11',
			date: '2020-02-16',
			summary: 'New features are added: <b>Chat, Admin Page</b>'
		},
		VER001012: {
			version: 'Ver.1.12',
			date: '2020-02-23',
			summary: 'New feature is added: <b>Group Chat</b>'
		},
		VER001013: {
			version: 'Ver.1.13',
			date: '2020-02-24',
			summary: 'New feature is added: <b>Chat as an anonymous user</b>'
		},
		VER001014: {
			version: 'Ver.1.14',
			date: '2020-02-26',
			summary: 'New feature is added: <b>User group security</b>'
		},
		VER001015: {
			version: 'Ver.1.15',
			date: '2020-02-26',
			summary: 'Feature is improved: <b>Increase performance in Timeline page</b>'
		},
		VER001016: {
			version: 'Ver.1.16',
			date: '2020-02-26',
			summary: 'New Feature is added: <b>PWA for safari</b>'
		},
		VER001017: {
			version: 'Ver.1.17',
			date: '2020-03-02',
			summary: 'New Features are added: <b>Popup for install app, Using local storage to increase app speed</b>'
		},
		VER001018: {
			version: 'Ver.1.18',
			date: '2020-03-03',
			summary: 'Backend features are improved: <b>Made Vuex module files, Changed functions location</b>'
		},
		VER001019: {
			version: 'Ver.1.19',
			date: '2020-03-04',
			summary: 'Backend features are improved: <b>Log, Push Notification, Chat timeline</b>'
		},
		VER001020: {
			version: 'Ver.1.20',
			date: '2020-03-05',
			summary: 'Feature is improved: <b>Send push notification of forget password request</b>'
		},
		VER001021: {
			version: 'Ver.1.21',
			date: '2020-05-28',
			summary: 'Backend features are improved: <b>Log Mode, Env mode, QA Env, Test user for phone number sign up, Local functions emulator</b>.<br>New feature added: <b>Open training by admin, Disable user by admin, Force reset password</b>.<br>Existing feature improved: <b>Slide show content for training</b>.<br>Minor bug fixes.'
		},
		VER001022: {
			version: 'Ver.1.22',
			date: '2020-06-05',
			summary: 'New Features are added: <b>Preview pages, API key for external systems</b>'
		},
		VER001023: {
			version: 'Ver.1.23',
			date: '2020-06-21',
			summary: 'Backend feature is improved: <b>App Logs</b>'
		},
		VER001024: {
			version: 'Ver.1.24',
			date: '2020-06-28',
			summary: 'New feature is added: <b>File upload (only for QA env)</b>'
		},
		VER001025: {
			version: 'Ver.1.25',
			date: '2020-07-03',
			summary: 'New feature is added: <b>Markdown</b>, <b>Nuto Sans Font</b>'
		},
		VER001026: {
			version: 'Ver.1.26',
			date: '2020-07-04',
			summary: 'New feature is added: <b>Training Builder, Lang & Style Builder (only for QA env)</b>'
		},
		VER001027: {
			version: 'Ver.1.27',
			date: '2020-07-14',
			summary: 'New feature is added: <b>CSV stepper tempolate, VeeValidation</b>'
		},
		VER001028: {
			version: 'Ver.1.28',
			date: '2020-07-15',
			summary: 'Feature is improved: Menu Group is saved in cookie'
		},
		VER001029: {
			version: 'Ver.1.29',
			date: '2020-08-21',
			summary: 'New Features are added: <b>Api Encryption, Api Authentication</b>'
		},
		VER001030: {
			version: 'Ver.1.30',
			date: '2020-08-31',
			summary: 'New Features are added: <b>Refresh local storage & cookie</b>'
		},
		VER001031: {
			version: 'Ver.1.31',
			date: '2020-09-10',
			summary: 'New Features are added: <b>Admin Menu</b>, <b>Csv Upload</b>'
		},
		VER001032: {
			version: 'Ver.1.32',
			date: '2020-09-22',
			summary: 'Features are improved: <b>Admin Menu</b>, <b>Builder Menu</b>, <b>API</b>'
		},
		VER001033: {
			version: 'Ver.1.33',
			date: '2020-09-25',
			summary: 'Features are improved.',
			description: [
				'- System bar is shown in QA & DEV environment.',
				'- Some bugs are fixed.'
			],
			relatedTestSuite: []
		},
		VER001034: {
			version: 'Ver.1.34',
			date: '2020-10-08',
			summary: 'Features are improved.',
			description: [
				'- Source code size is reduced.',
				'- Some bugs are fixed.'
			],
			relatedTestSuite: []
		},
		VER001035: {
			version: 'Ver.1.35',
			date: '2020-10-15',
			summary: 'Features are improved.',
			description: [
				'- Debug button is improved.',
				'- Some bugs are fixed.'
			],
			relatedTestSuite: []
		},
		VER001036: {
			version: 'Ver.1.36',
			date: '2020-10-22',
			summary: 'Features are improved.',
			description: [
				'- Security group for page contents.'
			],
			relatedTestSuite: []
		},
		VER001037: {
			version: 'Ver.1.37',
			date: '2020-10-23',
			summary: 'Features are improved.',
			description: [
				'- App input data.',
				'- App training input data.'
			],
			relatedTestSuite: []
		},
		VER001038: {
			version: 'Ver.1.38',
			date: '2020-10-24',
			summary: 'Features are improved.',
			description: [
				'- CSV upload for admin setting.'
			],
			relatedTestSuite: []
		},
		VER001039: {
			version: 'Ver.1.39',
			date: '2020-10-28',
			summary: 'Features are improved.',
			description: [
				'- Training features are adjusted with new system.'
			],
			relatedTestSuite: []
		},
		VER001040: {
			version: 'Ver.1.40',
			date: '2020-11-05',
			summary: 'Features are improved.',
			description: [
				'- Move point data to new system. (Only for developer)'
			],
			relatedTestSuite: []
		},
		VER001041: {
			version: 'Ver.1.41',
			date: '2020-11-06',
			summary: 'Features are improved.',
			description: [
				'- Local/Server log mode',
				'- Text message for progress circular'
			],
			relatedTestSuite: []
		},
		VER001042: {
			version: 'Ver.1.42',
			date: '2020-11-12',
			summary: 'New Features are added.',
			description: [
				'- Point API',
				'- Dev Log (Only for developer)'
			],
			relatedTestSuite: []
		},
		VER001043: {
			version: 'Ver.1.43',
			date: '2020-11-16',
			summary: 'New Features are added.',
			description: [
				'- GPU Accelerator for AI'
			],
			relatedTestSuite: []
		},
		VER001044: {
			version: 'Ver.1.44',
			date: '2020-12-02',
			summary: 'New Features are added.',
			description: [
				'- Common Style',
				'- Send Notification From Admin',
				'- Some feature changes such as menus -> menuItems'
			],
			relatedTestSuite: []
		},
		VER001045: {
			version: 'Ver.1.45',
			date: '2020-12-29',
			summary: 'Features are fixed.',
			description: [
				'- Chat & Timeline'
			],
			relatedTestSuite: []
		},
		VER001046: {
			version: 'Ver.1.46',
			date: '2021-01-02',
			summary: 'New Features are added.',
			description: [
				'- App & Component Builder'
			],
			relatedTestSuite: []
		},
		VER001047: {
			version: 'Ver.1.47',
			date: '2021-01-05',
			summary: 'Features are improved.',
			description: [
				'- Profile',
				'- Admin Setting'
			],
			relatedTestSuite: []
		},
		VER001048: {
			version: 'Ver.1.48',
			date: '2021-01-05',
			summary: 'Features are improved.',
			description: [
				'- Profile (Get Address By Postcode)',
				'- Mobile Menu'
			],
			relatedTestSuite: []
		}
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
